import { Component, Input, OnInit, Renderer2 } from "@angular/core";
import {
  ReactiveFormsModule,
  UntypedFormControl,
  UntypedFormGroup,
} from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { GeoService, UtilityService } from "../../services";

import { CustomCookieServiceService } from "../../services/custom-cookie-service.service";
import { debounceTime, Subject } from "rxjs";
import { Subscription } from "rxjs";

@Component({
  selector: "",
  template: "",
  imports: [ReactiveFormsModule, TranslateModule],
})
export class NewAddressFormBaseComponent implements OnInit {
  @Input() parentForm: UntypedFormGroup;
  @Input() isNewBlueDesign: boolean = false;

  onKeyUp = new Subject();
  private onKeyUpSubs: Subscription;

  constructor(
    public cookieService: CustomCookieServiceService,
    public geoService: GeoService,
    public renderer2: Renderer2,
    public utilityService: UtilityService,
  ) {
    this.geoService.initForm();
    this.onKeyUpSubs = this.onKeyUp
      .pipe(debounceTime(400))
      .subscribe((resp) => {
        this.updateFields();
      });
  }

  ngOnInit(): void {
    this.geoService.cityField = this.parentForm.get(
      "city",
    ) as UntypedFormControl;
    this.geoService.houseNumberField = this.parentForm.get(
      "houseNumber",
    ) as UntypedFormControl;
    this.geoService.postCodeField = this.parentForm.get(
      "postCode",
    ) as UntypedFormControl;
    this.geoService.streetField = this.parentForm.get(
      "street",
    ) as UntypedFormControl;

    this.setReadOnlyFields();
    this.addInputFilters();
  }

  setReadOnlyFields(): void {
    this.geoService.formFields.forEach((field) => {
      const control = this.parentForm.get(field.name) as UntypedFormControl;
      if (this.isReadOnly(field)) {
        control.disable();
      } else {
        control.enable();
      }
    });
  }

  updateFields() {
    if (this.geoService.isFormValid(this.parentForm, true)) {
      this.geoService.validateAddress();
    }
  }

  isReadOnly(field): boolean {
    return (
      this.geoService.language == "nl" &&
      (field.name == "street" || field.name == "city")
    );
  }

  addInputFilters(): void {
    this.geoService.houseNumberField.valueChanges.subscribe((value) => {
      if (value) {
        const filtered = value.replace(/[^0-9]/g, "");
        if (filtered !== value) {
          this.geoService.houseNumberField.setValue(filtered, {
            emitEvent: false,
          });
        }
      }
    });
    this.geoService.postCodeField.valueChanges.subscribe((value) => {
      if (value) {
        const filtered = value.replace(/[^a-zA-Z0-9]/g, "");
        if (filtered !== value) {
          this.geoService.postCodeField.setValue(filtered, {
            emitEvent: false,
          });
        }
      }
    });
  }

  ngOnDestroy() {
    this.onKeyUpSubs.unsubscribe();
  }
}
